import { render } from "./Renewals.vue?vue&type=template&id=b95d66d8&scoped=true"
import script from "./Renewals.vue?vue&type=script&lang=js"
export * from "./Renewals.vue?vue&type=script&lang=js"

import "./Renewals.vue?vue&type=style&index=0&id=b95d66d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b95d66d8"

export default script